(() => {
  if (window.customElements.get('srl-color-low-stock')) return;

  class SrlColorLowStock extends HTMLElement {
    connectedCallback() {
      this._onVariantChanged = this._onVariantChanged.bind(this);
      this._form = document.forms[this.getAttribute('form')];
      this._form?.addEventListener('variant:change', this._onVariantChanged);
    }

    disconnectedCallback() {
      this._form?.removeEventListener('variant:change', this._onVariantChanged);
    }

    _onVariantChanged(event) {
      const variant = event.detail && event.detail.variant;
      const position = parseInt(this.getAttribute('data-option-position') || '0', 10);

      if (!variant) {
        this.hidden = true;
        return;
      }

      if (position < 1) {
        this.querySelectorAll('.srl-low-stock-label, [data-color]').forEach((item) => {
          item.removeAttribute('hidden');
        });
        this.hidden = false;
        return;
      }

      const color = (variant.options && variant.options[position - 1]) || variant[`option${position}`] || '';
      let hasVisible = false;

      this.querySelectorAll('[data-color]').forEach((item) => {
        const isMatch = item.getAttribute('data-color') === color;
        item.toggleAttribute('hidden', !isMatch);
        if (isMatch) hasVisible = true;
      });

      this.hidden = !hasVisible;
    }
  }

  window.customElements.define('srl-color-low-stock', SrlColorLowStock);
})();
